import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section id="contact-section" className="section">
      <div className="container">
        {/* LEFT SIDE: Info Card (Let's Work Together) */}
        <div className="infoSide">
          <span className="badge">REACH OUT</span>
          <h2 className="heading">
            Let’s Work <br /> Together
          </h2>
          <p className="description">
            Have a project in mind or just want to say hi? We’d love to hear
            from you and explore new opportunities.
          </p>

          <div className="contactDetails">
            <div className="contactItem">
              <div className="iconBox">✉️</div>
              <span className="text">Gauravtiwari78007@gmail.com</span>
            </div>
            <div className="contactItem">
              <div className="iconBox">📞</div>
              <span className="text">+91 9266702027</span>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE: Attached Image & Form */}
        <div className="rightWrapper">
          {/* Telephone Image */}
          <div className="imageColumn">
            <img
              src="telephone.jpg"
              alt="Contact Us"
              className="fullImage"
              onError={(e) => {
                e.target.src =
                  "https://images.unsplash.com/photo-1520923642038-b4259a3199c3?auto=format&fit=crop&q=80&w=400";
              }}
            />
            <div className="imageOverlay"></div>
          </div>

          {/* Form Card */}
          <div className="formSide">
            <form className="form" onSubmit={(e) => e.preventDefault()}>
              <h3 className="formTitle">Send us a Message</h3>

              <div className="inputGroup">
                <label className="label">Full Name</label>
                <input type="text" placeholder="John Doe" className="input" />
              </div>

              <div className="inputGroup">
                <label className="label">Email Address</label>
                <input
                  type="email"
                  placeholder="john@example.com"
                  className="input"
                />
              </div>

              <div className="inputGroup">
                <label className="label">Message</label>
                <textarea
                  placeholder="Tell us about your project..."
                  rows="4"
                  className="textarea"
                ></textarea>
              </div>

              <button type="submit" className="button">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
